import React from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection({ heading, subheading }) {
  return (
    <div style={styles.hero}>
      <div style={styles.circle1} />
      <div style={styles.circle2} />

      <div style={styles.content}>
        <div style={styles.badge}>🌿 Willkommen in der Natur</div>
        <h1 style={styles.heading}>{heading}</h1>
        <p style={styles.subheading}>{subheading}</p>
        <div style={styles.actions}>
          <Link to="/buchung" style={styles.ctaPrimary}>Jetzt anfragen</Link>
          <Link to="/galerie" style={styles.ctaSecondary}>Galerie ansehen</Link>
        </div>
      </div>

      <div style={styles.waveWrapper}>
        <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: 'block', width: '100%', height: '80px' }}>
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#ffffff"/>
        </svg>
      </div>
    </div>
  );
}

const F = "'Inter', system-ui, sans-serif";

const styles = {
  hero: {
    position: 'relative',
    overflow: 'hidden',
    background: 'linear-gradient(160deg, #155d33 0%, #1e8449 55%, #27ae60 100%)',
    minHeight: '520px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  circle1: {
    position: 'absolute',
    top: '-100px',
    right: '-100px',
    width: '500px',
    height: '500px',
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.04)',
    pointerEvents: 'none',
  },
  circle2: {
    position: 'absolute',
    bottom: '-120px',
    left: '-80px',
    width: '420px',
    height: '420px',
    borderRadius: '50%',
    background: 'rgba(0,0,0,0.06)',
    pointerEvents: 'none',
  },
  content: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    padding: '4.5rem 2rem 6.5rem',
    maxWidth: '720px',
  },
  badge: {
    display: 'inline-block',
    backgroundColor: 'rgba(255,255,255,0.12)',
    color: 'rgba(255,255,255,0.9)',
    padding: '0.35rem 1rem',
    borderRadius: '4px',
    fontSize: '0.78rem',
    fontFamily: F,
    fontWeight: '600',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    marginBottom: '1.4rem',
    border: '1px solid rgba(255,255,255,0.18)',
  },
  heading: {
    color: 'white',
    fontSize: 'clamp(2.2rem, 5.5vw, 3.5rem)',
    fontFamily: F,
    fontWeight: '700',
    lineHeight: '1.15',
    marginBottom: '1.1rem',
    letterSpacing: '-0.8px',
  },
  subheading: {
    color: 'rgba(255,255,255,0.8)',
    fontSize: 'clamp(1rem, 2.2vw, 1.2rem)',
    fontFamily: F,
    fontWeight: '400',
    marginBottom: '2.4rem',
    lineHeight: '1.7',
  },
  actions: {
    display: 'flex',
    gap: '0.85rem',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  ctaPrimary: {
    display: 'inline-block',
    backgroundColor: 'white',
    color: '#1e8449',
    textDecoration: 'none',
    padding: '0.85rem 2.2rem',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '0.95rem',
    fontFamily: F,
    boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
  },
  ctaSecondary: {
    display: 'inline-block',
    backgroundColor: 'transparent',
    color: 'white',
    textDecoration: 'none',
    padding: '0.85rem 2.2rem',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '0.95rem',
    fontFamily: F,
    border: '1.5px solid rgba(255,255,255,0.45)',
  },
  waveWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
  },
};
